import { useEffect, useState } from 'react';
import { getUserTeamContexts, type TeamContext } from '@/api/teams';

const ROLE_LABELS: Record<TeamContext['user_role'], string> = {
  ADMIN: 'Admin',
  LEADER: 'Líder',
  EDITOR: 'Editor',
  MEMBER: 'Membro',
};

export function MemberTeamsSection() {
  const [contexts, setContexts] = useState<TeamContext[]>([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    getUserTeamContexts()
      .then(setContexts)
      .finally(() => setLoading(false));
  }, []);

  if (loading) {
    return (
      <div className="mt-10">
        <h2 className="text-2xl font-semibold text-white mb-6">Suas Equipes</h2>
        <p className="text-white/40 text-sm">Carregando equipes...</p>
      </div>
    );
  }

  if (contexts.length === 0) {
    return null;
  }

  return (
    <div className="mt-10">
      <h2 className="text-2xl font-semibold text-white mb-2">Suas Equipes</h2>
      <p className="text-white/40 text-sm mb-6">
        Equipes das quais você faz parte. O plano de cada equipe pertence ao seu dono.
      </p>

      <div className="space-y-3">
        {contexts.map((ctx) => (
          <div
            key={ctx.team_id}
            className="bg-[#111111] border border-white/5 rounded-lg p-5"
          >
            <div className="flex items-start justify-between gap-4">
              <div className="min-w-0">
                <p className="text-white font-semibold truncate">{ctx.team_name}</p>
                <p className="text-white/40 text-sm mt-1">
                  {ctx.member_count} {ctx.member_count === 1 ? 'membro' : 'membros'}
                </p>
              </div>
              <span className="shrink-0 text-xs font-medium px-2 py-1 rounded-full bg-white/5 text-white/60">
                {ROLE_LABELS[ctx.user_role]}
              </span>
            </div>

            <div className="mt-4 pt-4 border-t border-white/5 flex items-center gap-2">
              <svg
                className="w-4 h-4 text-[#C8A96E] shrink-0"
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth={2}
                  d="M9 12l2 2 4-4m5.618-4.016A11.955 11.955 0 0112 2.944a11.955 11.955 0 01-8.618 3.04A12.02 12.02 0 003 9c0 5.591 3.824 10.29 9 11.622 5.176-1.332 9-6.03 9-11.622 0-1.042-.133-2.052-.382-3.016z"
                />
              </svg>
              <p className="text-sm text-white/50">
                Plano do dono:{' '}
                <span className="text-[#C8A96E] font-medium">{ctx.owner_plan_name}</span>
                {' · '}
                <span className="text-white/40">{ctx.owner_name}</span>
              </p>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
